import { Controller, FetchOptions, Result } from 'bernie-core';
import { ZendeskLoginExecutor } from '../../components';
import { withSecurity } from '../../components/auth';

export class ZendeskLoginController implements Controller {
  public routeName = 'zendesklogin';
  public pageId = 'pages.zendesklogin';
  public path = '/affiliate-hub/zendesk/login';
  public exact = true;
  public bundles = [];
  public deferTo = ZendeskLoginExecutor;

  public component = withSecurity(this.deferTo, this.path, false);

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Affiliate Hub Zendesk Login' });
  }
}
